import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import { EncryptPayloadModel } from '../models/encrpt-payload.model';

@Injectable()
export class EncrptPayloadAdapter implements IAdapter<EncryptPayloadModel> {
  adaptToModel(resp: any): any {
    return resp;
  }
  adaptFromModel(data: EncryptPayloadModel): any {
    return {
      data: data.data,
      
    };
  }
}
